/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 12 2023
 **/

import { Column, Image as ImageComp, ImageCompProps } from "@/frameworks/designStuff/components";
import cx from "classnames";

function Card({ children }: { children?: React.ReactNode }) {
	return <>{children}</>;
}

Card.Layout = Layout;
Card.Image = Image;
Card.Content = Content;

export interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
	children: React.ReactNode;
	type: "outer" | "inner";
}

function Layout({ className, ...props }: LayoutProps) {
	return <Column className={cx("card__layout", className)} {...props} />;
}
export type CardImageProps = ImageCompProps;

/**
A component that renders an image with the given CardImageProps.
@param src - 이미지 리소스
@param errorSrc - 이미지 출력을 실패할 경우, 다른 이미지 리소스
*/
function Image({ className, ...props }: CardImageProps) {
	return <ImageComp className={cx("card__image", className)} {...props} />;
}

export type ContentProps = React.HtmlHTMLAttributes<HTMLDivElement>;

function Content({ className, ...props }: ContentProps) {
	return <div className={cx("card__content", className)} {...props} />;
}

export default Card;
